<template>
  <div>
    <!-- loading -->
    <loading v-if="loading === 1" style="min-height:620px;"></loading>
    <div v-show="loading === 0">
      <div class="main-content" v-if="(evaluate_result.abilities && evaluate_result.abilities.length > 0)||(evaluate_result.tags && evaluate_result.tags.length > 0)||(evaluate_result.indicators && evaluate_result.indicators.length > 0)">
        <h2 class="m-b-sm">
          <span>{{questionnaire.score_name}}测评报告</span>
          <span class="btn btn-primary right" @click="download()" v-if="questionnaire.category === 2">下载报告</span>
        </h2>
        <div class="b-b"></div>
        <div id="report-area" class="row">
          <div class="col-xs-12">
            <div class="row">
              <div class="col-xs-12 m-t-b-sm">
                <div style="height:20px;background:#42b983;"></div>
              </div>
              <div class="col-xs-12">
                <div class="row">
                  <div class="col-xs-6">
                    <img src="/assets/images/psych2_4_2.jpg" alt="" class="psych-logo left" height="60">
                  </div>
                  <div class="col-xs-6">
                    <img src="/assets/images/lechenggu-logo.png" alt="" class="lechenggu-logo left right" height="60">
                  </div>
                </div>
              </div>
              <h1 class="p-t-b-md n-m-b text-center">{{questionnaire.score_name}}测评报告</h1>
            </div>
            <div class="row user-info snapshort">
              <div class="col-xs-12" v-if="questionnaire.category === 2">
                <div class="row">
                  <div class="col-xs-6">
                    <div class="line">
                      <span class="label">姓名:</span>
                      <span class="info">{{tester.realname?tester.realname:tester.nickname}}</span>
                    </div>
                    <div class="line">
                      <span class="label">邮箱:</span>
                      <span class="info">{{tester.email}}</span>
                    </div>
                    <div class="line" v-if="tester.phone">
                      <span class="label">手机:</span>
                      <span class="info">{{tester.phone}}</span>
                    </div>
                  </div>
                  <div class="col-xs-6">
                    <img :src="tester.avatar" alt="" width="100" class="m-r-sm right" v-if="tester.avatar">
                  </div>
                </div>
                <div class="b-b m-t-b-sm "></div>
              </div>
              <div class="col-xs-12">
                <div class="row">
                  <div class="col-xs-12">
                    <div class="line">
                      <span class="label">得分:</span>
                      <span class="info num">{{evaluate_result.score.toFixed(2)}}</span>
                    </div>
                  </div>
                  <div class="col-xs-12" v-if="evaluate_result.grade && evaluate_result.grade.desc">
                    <div class="line">
                      <div class="label p-b-sm">总结：</div>
                      <div class="desc" v-html="evaluate_result.grade && evaluate_result.grade.desc"></div>
                    </div>
                  </div>
                  <div class="col-xs-12" v-if="evaluate_result.grade && evaluate_result.grade.suggestion">
                    <div class="line">
                      <div class="label p-b-sm">建议：</div>
                      <div class="desc" v-html="evaluate_result.grade && evaluate_result.grade.suggestion"></div>
                    </div>
                  </div>
                  <div class="col-xs-12" v-if="evaluate_result.grade && evaluate_result.grade.improvement">
                    <div class="line">
                      <div class="label p-b-sm">提升：</div>
                      <div class="desc" v-html="evaluate_result.grade && evaluate_result.grade.improvement"></div>
                    </div>
                  </div>
                </div>
                <div class="b-b m-t-b-sm "></div>
              </div>
            </div>
            <div class="row snapshort m-b-sm">
              <!-- 总分 start -->
              <div class="col-xs-12 ">
                <div class="line">
                  <div class="label p-b-sm">总分:</div>
                  <div class="col-xs-12">
                    <div class="row">
                      <div class="dimension" :class="tag_class">
                        <div class="row name">{{evaluate_result.score_name}}</div>
                        <div class="row score">{{evaluate_result.score.toFixed(2)}}</div>
                      </div>
                      <div class="dimension" :class="tag_class" v-for="tag in evaluate_result.tags" :key="tag._id">
                        <div class="row name">{{tag.name}}</div>
                        <div class="row score">{{tag.score.toFixed(2)}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <div class="" id="bar-area" style="width:100%;height:300px;"></div>
                    <div class="b-b m-b-sm "></div>
                  </div>
                </div>
              </div>
              <!-- 总分 end -->
              <!-- 维度得分 start -->
              <div class="col-xs-12">
                <div class="line">
                  <div class="label p-b-sm">维度得分:</div>
                  <div class="col-xs-12">
                    <div class="row">
                      <div class="dimension" :class="indicator_class" v-for="indicator in evaluate_result.indicators" :key="indicator._id">
                        <div class="row name">{{indicator.name}}</div>
                        <div class="row score">{{indicator.score.toFixed(2)}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <div class="row">
                      <radar style="height:350px;" :class="{'col-xs-12':aspect_radars.length=== 1,'col-xs-6':aspect_radars.length!== 1}" :title="radar_data.title" :legend="radar_data.legend" :series="radar_data.series" :indicator="radar_data.indicator" v-for="radar_data in aspect_radars" :key="radar_data.name"></radar>
                    </div>
                  </div>
                </div>
                <!-- 维度得分 end -->
              </div>
            </div>
            <div class="row snapshot ability open" :data-index="ind" v-for="(aspect,ind) in evaluate_result.aspects" :key="aspect._id" :class="{'open': aspect.is_open === 1}">
              <div class="col-xs-12 m-b-sm ">
                <div class="btn btn-md n-b-r col-xs-12 n-f btn-success">
                  <div class="row">
                    <div class="col-sm-3 col-xs-12">
                      <span>能力名称：</span>
                      <span class="bold">{{aspect.name}}</span>
                    </div>
                  </div>
                </div>
                <div class="detail col-xs-12">
                  <div class="row p-b-sm">
                    <div class="col-xs-12" :class="{'col-sm-6':!aspect.grade,'col-sm-4':aspect.grade}" v-if="aspect.desc">
                      <div class="row p-l-r-xs">
                        <div class="desc" v-html="aspect.desc"></div>
                      </div>
                    </div>
                    <div class="col-xs-12" :class="{'col-sm-6':aspect.grade || aspect.desc,'col-sm-4':aspect.grade&&aspect.desc}">
                      <div class="row">
                        <Scatter class="col-xs-12 n-p-l n-p-r" style="height:200px;" :code="code" :type="3" :target="aspect._id" :name="aspect.name" :score="aspect.score"></Scatter>
                        <div class="col-xs-12 m-t-xs text-center p-b-xs" style="font-size:14px;">
                          <span>
                            <i class="score">{{aspect.score.toFixed(2)}}</i>分</span>
                          <!-- ,领先<span class="score">{{(aspect.rate*100).toFixed(2)}}%</span>的测评用户 -->
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-4" v-if="aspect.grade">
                      <div class="row p-b-sm" v-if="aspect.grade.desc">
                        <div class="col-xs-12" style="padding-left:5px;">
                          <div class="label">解析：</div>
                          <div class="desc" v-html="aspect.grade.desc"></div>
                        </div>
                      </div>

                      <div class="row p-b-sm" v-if="aspect.grade.suggestion">
                        <div class="col-xs-12" style="padding-left:5px;">
                          <div class="label">建议：</div>
                          <div class="desc" v-html="aspect.grade.suggestion"></div>
                        </div>
                      </div>
                      <div class="row p-b-sm" v-if="aspect.grade.improvement">
                        <div class="col-xs-12" style="padding-left:5px;">
                          <div class="label">提升：</div>
                          <div class="desc" v-html="aspect.grade.improvement"></div>
                        </div>
                      </div>
                    </div>
                    <div class="b-b m-b-xs"></div>
                  </div>
                  <div class="row p-b-sm">
                    <div class="row">
                      <div class="indicator col-xs-12" :class="{'col-sm-4':aspect.indicators.length >= 3,'col-sm-6':aspect.indicators.length <=2}" v-for="indicator in aspect.indicators" :key="indicator._id">
                        <Scatter class="col-xs-12 n-p-l n-p-r" style="height:200px;" :code="code" :type="1" :target="indicator.indicator.indicator" :name="indicator.indicator.name" :score="indicator.indicator.score" :rate="indicator.rate"></Scatter>
                        <time-scatter class="col-xs-12 n-p-l n-p-r" style="height:200px;" :code="code" :type="1" :target="indicator.indicator.indicator" :name="indicator.indicator.name" :score="indicator.indicator.duration" :rate="indicator.rate" v-if="questionnaire.category === 2"></time-scatter>
                        <div class="col-xs-12 m-t-xs text-center p-b-xs" style="font-size:14px;">
                          <span class="score">{{indicator.indicator.score.toFixed(2)}}分</span>,领先
                          <span class="score">{{(indicator.indicator.rate*100).toFixed(2)}}%</span>的测评用户</div>
                        <div class=" p-t-b-sm" v-if="indicator.indicator.grade_desc">
                          <div class="col-xs-12">
                            <div class="row">
                              <div class="label m-b-xs">指标解析：</div>
                              <div class="desc" v-html="indicator.indicator.grade_desc"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <h5 class="text-center">
                <span>本报告由</span>
                <a href="http://www.psych.cas.cn" title="中国科学院心理研究所·心理健康应用中心" alt="中国科学院心理研究所·心理健康应用中心" style="color:#000">中国科学院心理研究所·心理健康应用中心</a>
                <span>提供测评技术支持</span>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Evaluate from "../../../resource/evaluate";

import async from "async";
import H2C from "html2canvas";
import jQuery from "jquery";
import Echarts from "echarts/lib/echarts.js";
import "echarts/lib/chart/bar.js";
import "echarts/lib/component/legend";
import "echarts/lib/component/title";
import "echarts/lib/component/tooltip";
import SvgCircle from "../../blocks/svg-circle.vue";
import Radar from "../../blocks/radar.vue";
import Scatter from "../../blocks/scatter.vue";
import TimeScatter from "../../blocks/time-scatter.vue";
import Loading from "../../blocks/loading.vue";
const IDReg = /^[0-9a-f]{24}$/i;
const colors = ["#5793f3", "#d14a61", "#675bba"];

export default {
  name: "EvaluateDimensionReportTpl",
  props: {
    code: {
      // 字符串
      type: String,
      required: true,
      validator: v => IDReg.test(v)
    },
    questionnaire: {
      type: Object,
      required: true,
      default: () => ({})
    },
    tester: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data: function() {
    return {
      loading: 1,
      company: {},
      is_mounted: false,
      radar: null,
      bar: null,
      evaluate_result: {
        abilities: [],
        tags: [],
        indicators: [],
        aspects: []
      },
      detail_data: 0,
      radar_data: {
        title: "",
        legend: [],
        series: [],
        indicator: []
      },
      view_indicators: {},
      view_tags: {},
      view_abilities: {},
      aspect_radars: []
    };
  },
  computed: {
    tag_class: function() {
      const that = this;
      const amount = 1 + that.evaluate_result.tags.length;
      if (amount % 3 === 0) {
        if (amount > 6) {
          return "col-xs-6 col-sm-4 col-md-2";
        } else {
          return "col-xs-6 col-sm-4";
        }
      } else if (amount % 2 === 0) {
        if (amount > 6) {
          return "col-xs-6 col-sm-4 col-md-2";
        } else {
          return `col-xs-6 col-sm-${12 / amount}`;
        }
      }
      return "col-xs-6 col-sm-4 col-md-2";
    },
    indicator_class: function() {
      const that = this;
      const amount = 1 + that.evaluate_result.indicators.length;
      if (amount % 3 === 0) {
        if (amount > 6) {
          return "col-xs-6 col-sm-4 col-md-2";
        } else {
          return "col-xs-6 col-sm-4";
        }
      } else if (amount % 2 === 0) {
        if (amount > 6) {
          return "col-xs-6 col-sm-4 col-md-2";
        } else {
          return `col-xs-6 col-sm-${12 / amount}`;
        }
      }
      return "col-xs-6 col-sm-4 col-md-2";
    }
  },

  components: {
    SvgCircle,
    Radar,
    Scatter,
    TimeScatter,
    Loading
  },
  watch: {
    // 监控数据
    evaluate: function(now, pre) {
      if (now.name !== pre.name) {
        document.title = `测评报告：${now.name}`;
      }
    },
    "evaluate_result.abilities": function(now) {
      let that = this;
      if (that.is_mounted) {
        setTimeout(function() {
          that.buildBar();
        }, 300);
      }
    }
  },
  created: function() {
    // 页面渲染完成后
    let that = this;
    that.loadReport();
  },
  mounted: function() {
    let that = this;
    that.is_mounted = true;
    if (that.evaluate_result) {
      setTimeout(function() {
        that.buildBar();
      }, 300);
    }
  },
  methods: {
    buildBar: function() {
      let that = this;
      if (!that.bar) {
        that.bar = Echarts.init(document.querySelector("#bar-area"));
      }
      let options = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data: ["总分"],
          orient: "vertical",
          right: "20px",
          show: false
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          axisLabel: {
            textStyle: {
              color: "#000000",
              fontSize: 14,
              fontWeight: "Bold"
            }
          },
          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "总分",
            type: "bar",
            barMaxWidth: "100",
            itemStyle: {
              normal: {
                color: function(params) {
                  return colors[params.dataIndex % 3];
                }
              }
            },
            label: {
              normal: {
                show: true,
                position: "top"
              }
            },
            data: []
          }
        ]
      };
      options.xAxis.data.push(that.evaluate_result.score_name);
      options.series[0].data.push(
        Number(that.evaluate_result.score.toFixed(2))
      );
      that.evaluate_result.aspects.forEach(function(aspect, index) {
        options.xAxis.data.push(aspect.name);
        options.series[0].data.push(Number(aspect.score.toFixed(2)));
      });
      that.bar.setOption(options);
    },
    loadReport: function() {
      const that = this;
      // 获取报告
      Evaluate.report({ code: that.code }).then(res => {
        const data = res.body;
        if (data.code === 0) {
          const _report = data.result;
          _report.indicators.forEach(indicator => {
            delete indicator._id;
            for (let p in indicator.indicator) {
              if (indicator.indicator.hasOwnProperty(p)) {
                indicator[p] = indicator.indicator[p];
              }
            }
            indicator.indicator = indicator._id;
            that.view_indicators[indicator.indicator] = indicator;
          });
          _report.tags.forEach(tag => {
            delete tag._id;
            for (let p in tag.tag) {
              if (tag.tag.hasOwnProperty(p)) {
                tag[p] = tag.tag[p];
              }
            }
            let radar = {
              title: `${tag.name}`,
              legend: ["基准线", that.tester.realname],
              indicator: [],
              series: [
                {
                  name: "基准线",
                  type: "radar",
                  tooltip: {
                    trigger: "item"
                  },
                  itemStyle: {
                    normal: {
                      areaStyle: { type: "default" },
                      color: function(data) {
                        return colors[0];
                      }
                    }
                  },
                  data: [
                    {
                      value: [],
                      name: "基准线"
                    }
                  ]
                },
                {
                  name: that.tester.realname,
                  type: "radar",
                  tooltip: {
                    trigger: "item"
                  },
                  itemStyle: {
                    normal: {
                      areaStyle: { type: "default" },
                      color: function(data) {
                        return colors[1];
                      }
                    }
                  },
                  data: [
                    {
                      value: [],
                      name: that.tester.realname
                    }
                  ]
                }
              ]
            };
            tag.tag = tag.tag._id;
            tag.indicators = tag.indicators.map(indicator => {
              indicator.indicator = that.view_indicators[indicator.indicator];
              radar.indicator.push({
                name: indicator.indicator.name,
                max: indicator.indicator.point_system
              });
              radar.series[0].data[0].value.push(indicator.threshold_value);
              radar.series[1].data[0].value.push(indicator.indicator.score);
              return indicator;
            });
            if (tag.indicators.length >= 3) {
              that.aspect_radars.push(radar);
              tag.radar = radar;
            }
            that.view_tags[tag.tag] = tag;
          });
          _report.abilities.forEach(abitilty => {
            delete abitilty._id;
            for (let p in abitilty.abitilty) {
              if (abitilty.abitilty.hasOwnProperty(p)) {
                abitilty[p] = abitilty.abitilty[p];
              }
            }
            let radar = {
              title: `${abitilty.name}`,
              legend: ["基准线", that.tester.realname],
              indicator: [],
              series: [
                {
                  name: "基准线",
                  type: "radar",
                  tooltip: {
                    trigger: "item"
                  },
                  itemStyle: {
                    normal: {
                      areaStyle: { type: "default" },
                      color: function(data) {
                        return colors[0];
                      }
                    }
                  },
                  data: [
                    {
                      value: [],
                      name: "基准线"
                    }
                  ]
                },
                {
                  name: that.tester.realname,
                  type: "radar",
                  tooltip: {
                    trigger: "item"
                  },
                  itemStyle: {
                    normal: {
                      areaStyle: { type: "default" },
                      color: function(data) {
                        return colors[1];
                      }
                    }
                  },
                  data: [
                    {
                      value: [],
                      name: that.tester.realname
                    }
                  ]
                }
              ]
            };
            abitilty.abitilty = abitilty.abitilty._id;
            abitilty.indicators = abitilty.indicators.map(indicator => {
              indicator.indicator = that.view_indicators[indicator.indicator];
              radar.indicator.push({
                name: indicator.indicator.name,
                max: indicator.indicator.point_system
              });
              radar.series[0].data[0].value.push(indicator.threshold_value);
              radar.series[1].data[0].value.push(indicator.indicator.score);
              return indicator;
            });
            if (ability.indicators.length >= 3) {
              that.aspect_radars.push(radar);
              ability.radar = radar;
            }
            that.view_abilities[ability.ability] = ability;
          });
          if (that.questionnaire.struct_type === 2) {
            _report.aspects = _report.abilities;
          } else if (that.questionnaire.struct_type === 3) {
            _report.aspects = _report.tags;
          }
          that.evaluate_result = _report;
          that.loading = 0;
        } else {
          alert(data.msg);
        }
      });
    },
    download: function() {
      const that = this;
      const doc = window.document;
      async.mapLimit(
        doc.querySelectorAll(".snapshort"),
        2,
        (ra, done) => {
          H2C(ra, {
            background: "#fff",
            useCORS: true,
            onrendered: function(canvas) {
              done(null, {
                base64: canvas.toDataURL(),
                height: canvas.height,
                width: canvas.width
              });
            }
          });
        },
        (err, results) => {
          var $form = jQuery(
            '<form method="post" action="/api/base642pdf"></form>'
          );
          $form.append(
            '<textarea style="display:none;" name="base64" >' +
              JSON.stringify(results) +
              "</textarea>"
          );
          $form.append(
            `<input type="hidden" name="name" value="${that.tester.realname}-${
              that.questionnaire.alias
                ? that.questionnaire.alias
                : that.questionnaire.name
            }" />`
          );
          // $form.append(
          //   `<input type="hidden" name="height" value="${canvas.height}" />`
          // );
          // $form.append(
          //   `<input type="hidden" name="width" value="${canvas.width}" />`
          // );
          $form.append(`<input type="hidden" name="category" value="2" />`);
          jQuery(document.body).append($form);
          $form[0].submit();
          $form.remove();
        }
      );
    }
  },
  destroyed: function() {
    let that = this;
    if (that.radar) {
      that.radar.dispose();
      that.radar = null;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
#radar-area {
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// dimension.vue?3862b235